exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  position: fixed;\n  bottom: 0;\n  background: #f5f5f5;\n  border: 1px solid #e7e7e7;\n  z-index: 800;\n}\n\n.noscroll {\n  overflow: hidden;\n  height: 100%;\n  position: absolute;\n}\n\n#wrapper {\n  -moz-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  -webkit-transition: all 0.5s ease;\n  padding-left: 0;\n  transition: all 0.5s ease;\n}\n\n#wrapper.toggled {\n  padding-left: 220px;\n}\n\n#wrapper.toggled #sidebar-wrapper {\n  width: 220px;\n}\n\n#wrapper.toggled #page-content-wrapper {\n  margin-right: -220px;\n  /*position: absolute;*/\n}\n\n#sidebar-wrapper {\n  -moz-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  -webkit-transition: all 0.5s ease;\n  background: #1a1a1a;\n  height: 100%;\n  left: 220px;\n  margin-left: -220px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  transition: all 0.5s ease;\n  width: 0;\n  z-index: 1000;\n}\n\n#sidebar-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.fixed {\n  padding: 51px 0 30px 0 !important;\n}\n\n#page-content-wrapper {\n  padding: 0px 0 30px 0;\n  width: 100%;\n  min-height: 100vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/layout/app-layout/app-layout.component.css
// module id = ../../../../../src/app/layout/app-layout/app-layout.component.css
// module chunks = main